import qs from 'qs'

const fields = [
]

export const queryFranceEntryThumbnails = (options: QueryManyOptions) => {
  const sortKey = strapiGetI18nSortKey(options?.locale, 'titles.i18n_string')

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      sort: options?.sort || [`${sortKey}:asc`],
      pagination: {
        page: options?.page || 1,
        pageSize: options?.pageSize || 10,
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        blocks: {
          ...queryFragmentBlockImages
        }
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `france-entries?${query}`
}
